/* Customall gallery → Shopify popup (lightbox), for consistency with the
   Customily / theme gallery which already opens the theme's <product-modal>
   on click.

   On Customall products the visible gallery is the app's Embla carousel
   inside #artwork-preview, and the theme <media-gallery> (which carries the
   <modal-opener> that opens the theme lightbox) is hidden by customall-v2.css.
   So clicking the Embla image does nothing but swipe.

   This wires a click on the MAIN Embla image to programmatically trigger the
   hidden theme modal-opener — reusing the exact same Shopify popup Customily
   uses (same close button, swipe, escape-to-close). The popup shows the
   product's uploaded gallery images (the towel/mug/etc. mockups). Thumbnail
   clicks and prev/next arrows keep their native Embla behaviour. */
(function () {
  function getOpener() {
    return document.querySelector(
      '.product__media-wrapper .product__modal-opener button, .product__media-wrapper modal-opener button'
    );
  }

  function getMainViewport() {
    /* The main Embla (not the .embla--thumb carousel). */
    var emblas = document.querySelectorAll('#artwork-preview .embla');
    for (var i = 0; i < emblas.length; i++) {
      if (!emblas[i].classList.contains('embla--thumb')) {
        return emblas[i].querySelector('.embla__viewport') || emblas[i];
      }
    }
    /* Fallback: the first viewport inside the preview. */
    return document.querySelector('#artwork-preview .embla__viewport');
  }

  var wired = false;

  function onClick(e) {
    /* Don't hijack the carousel's own prev/next buttons. */
    if (e.target.closest('.embla__button')) return;
    var opener = getOpener();
    if (opener) opener.click();
  }

  function wire() {
    if (wired) return;
    var main = getMainViewport();
    var opener = getOpener();
    if (!main || !opener) return;
    wired = true;
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', onClick);
  }

  function init() {
    wire();
    if (wired) return;
    /* Customall mounts the Embla asynchronously — keep trying for ~30s. */
    var observer = new MutationObserver(wire);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
